import React from 'react';

const FootnotesListItem = props => (
  <li>{props.footnote}</li>
)

export default FootnotesListItem;


// WEBPACK FOOTER //
// ./src/components/FootnotesListItem.js